import { SupplierSettingsMessage } from '../../../../types/SupplierSettingsMessage';
import { Switch } from '../../../cdl/Switch/Switch';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import { useSupplierSettingsOptimisticMutation } from '../../hooks/useSupplierSettingsOptimisticMutation';

interface SupplierNotificationSettingsProps {
    supplierSettings: SupplierSettingsMessage;
    supplierId: string;
}

export const SupplierNotificationSettings = ({ supplierSettings, supplierId }: SupplierNotificationSettingsProps) => {
    const editSupplierSettingsMutation = useSupplierSettingsOptimisticMutation(supplierId);

    const updateEmailSettings = (newSettings: Partial<SupplierSettingsMessage['emailCategorySettings']>) => {
        editSupplierSettingsMutation.mutate({
            id: supplierId,
            settings: {
                ...supplierSettings,
                emailCategorySettings: {
                    ...supplierSettings.emailCategorySettings,
                    ...newSettings,
                },
            },
        });
    };

    const emailCategorySettings = supplierSettings.emailCategorySettings;

    return (
        <Box display="flex" flexDirection="column" gap={24}>
            <Switch
                checked={emailCategorySettings.offerStateChange}
                onChange={(checked) =>
                    updateEmailSettings({
                        offerStateChange: checked,
                    })
                }
                label={translate('company.notificationSettings.statusUpdate')}
                description={translate('company.notificationSettings.statusUpdateDescription')}
            />
            <Switch
                checked={emailCategorySettings.offerUpdate}
                onChange={(checked) =>
                    updateEmailSettings({
                        offerUpdate: checked,
                    })
                }
                label={translate('company.notificationSettings.newDetails')}
                description={translate('company.notificationSettings.newDetailsDescription')}
            />
            <Switch
                checked={emailCategorySettings.newChatMessage}
                onChange={(checked) =>
                    updateEmailSettings({
                        newChatMessage: checked,
                    })
                }
                label={translate('company.notificationSettings.newChatMessages')}
            />
            <Switch
                checked={emailCategorySettings.systemReminder}
                onChange={(checked) =>
                    updateEmailSettings({
                        systemReminder: checked,
                    })
                }
                label={translate('company.notificationSettings.systemReminders')}
            />
        </Box>
    );
};
